import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=be5268ae&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be5268ae')) {
      api.createRecord('be5268ae', component.options)
    } else {
      api.reload('be5268ae', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=be5268ae&", function () {
      api.rerender('be5268ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Index.vue"
export default component.exports